import { Component, EventEmitter, HostBinding, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import "./veriNumberField.component.scss";

@Component({
    selector: "veri-number-field",
    template: require("./veriNumberField.component.html")
})
export class VeriNumberFieldComponent implements OnInit {

    @Input() minValue: number;
    @Input() maxValue: number;
    @Input() disabled: boolean;
    @Input() value: number = 0;
    @Output() valueChange = new EventEmitter<number>();
    @Output() onValueChanged = new EventEmitter<void>();

    constructor() { }

    ngOnInit(): void { }

    increaseValue(): void {
        if (this.disabled) {
            return;
        }

        if (this.value + 1 > this.maxValue) {
            return;
        }

        this.value += 1;

        this.valueChange.emit(this.value);
        this.onValueChanged.emit();
    }

    decreaseValue(): void {
        if (this.disabled) {
            return;
        }

        if (this.value - 1 < this.minValue) {
            return;
        }

        this.value -= 1;

        this.valueChange.emit(this.value);
        this.onValueChanged.emit();
    }

    onInputValueChanged(value: number): void {
        if (this.disabled) {
            return;
        }

        this.value = +value;

        this.valueChange.emit(this.value);
        this.onValueChanged.emit();
    }
}
